import { cva, type VariantProps } from 'class-variance-authority';
import type { ElementType, HTMLAttributes } from 'react';

import { cn } from '../cn';

const container = cva('mx-auto w-full px-gutter', {
  variants: {
    width: {
      page: 'max-w-(--container-page)',
      wide: 'max-w-(--container-wide)',
      /** Long-form reading width, about 75 characters. */
      content: 'max-w-(--container-content)',
      narrow: 'max-w-(--container-narrow)',
    },
  },
  defaultVariants: { width: 'page' },
});

/* HTMLAttributes because the elements this renders as disagree on legacy
   per-element attributes. Card does the same. */
type ContainerProps = HTMLAttributes<HTMLElement> &
  VariantProps<typeof container> & {
    as?: Extract<ElementType, 'div' | 'footer' | 'header' | 'main' | 'nav' | 'section'>;
  };

export const Container = ({ as: Tag = 'div', width, className, ...props }: ContainerProps) => (
  <Tag className={cn(container({ width }), className)} {...props} />
);
